import { Link } from '@chakra-ui/react';
import { isValidURL } from '../utils/isValidUrl';

const useLinkFormatter = (inputString, { linkRawUrls = true } = {}) => {
  const parseString = (inputString) => {
    // Check for incomplete/unclosed anchor tags — if any exist, render
    // the whole string as plain text to avoid broken partial rendering.
    const openTags = (inputString.match(/<a[\s>]/gi) || []).length;
    const closeTags = (inputString.match(/<\/a>/gi) || []).length;
    if (openTags !== closeTags) {
      return <span>{inputString}</span>;
    }

    const splitRegex = linkRawUrls
      ? /(<a.*?>.*?<\/a>|https?:\/\/[^\s]+)/
      : /(<a.*?>.*?<\/a>)/;
    const parts = inputString.split(splitRegex);
    return (
      <>
        {parts.map((part, index) => {
          if (part.startsWith('<a') && part.endsWith('</a>')) {
            const hrefMatch = part.match(/href=[''""'"](.*?)[''""'"]/);
            const rawHref = hrefMatch ? hrefMatch[1] : null;
            const normalizedHref = rawHref && /^www\./i.test(rawHref) ? `https://${rawHref}` : rawHref;
            const href = normalizedHref && isValidURL(normalizedHref) ? normalizedHref : null;
            const textMatch = part.match(/>(.*?)<\//);
            if (!rawHref) {
              return <span key={index}>{textMatch ? textMatch[1] : part}</span>;
            }
            const displayText = (textMatch ? textMatch[1] : '') || href || rawHref;
            return (
              <Link
                key={index}
                cursor="pointer"
                isExternal
                href={href}
                style={{ color: '#1D60D3' }}
              >
                {displayText}
              </Link>
            );
          } else if (linkRawUrls && isValidURL(part)) {
            const normalizedPart = /^www\./i.test(part) ? `https://${part}` : part;
            return (
              <Link
                key={index}
                cursor="pointer"
                isExternal
                href={normalizedPart}
                style={{ color: '#1D60D3' }}
              >
                {part}
              </Link>
            );
          }
          return <span key={index}>{part}</span>;
        })}
      </>
    );
  };

  return parseString(inputString);
};

export default useLinkFormatter;
